import React from 'react';
import { IMapPoint } from '../../../models/interfaces/IMapPoint';
import VideoSlide from './VideoSlide/VideoSlide';
import AudioSlide from './AudioSlide/AudioSlide';
import TextSlide from './TextSlide/TextSlide';
import ImageSlide from './ImageSlide/ImageSlide';

export type SlideProps = {
	point: IMapPoint;
	title?: string;
	setSheetOpen: React.Dispatch<React.SetStateAction<any>>;
	setDescription: React.Dispatch<React.SetStateAction<any>>;
};

const SlideHandler: React.FC<SlideProps> = ({
	point,
	title,
	setSheetOpen,
	setDescription,
}) => {
	const renderSlide = (point: IMapPoint) => {
		const sm = {
			has_video: point.poi_video ? true : false,
			has_audio: point.poi_audio ? true : false,
			has_image: point.poi_image ? true : false,
		};
		switch (true) {
			case sm.has_video:
				return (
					<VideoSlide
						point={point}
						title={title}
						setSheetOpen={setSheetOpen}
						setDescription={setDescription}
					/>
				);
			case sm.has_audio:
				return (
					<AudioSlide
						point={point}
						title={title}
						setSheetOpen={setSheetOpen}
						setDescription={setDescription}
					/>
				);
			case sm.has_image:
				return (
					<ImageSlide
						point={point}
						title={title}
						setSheetOpen={setSheetOpen}
						setDescription={setDescription}
					/>
				);
			default:
				return (
					<TextSlide
						point={point}
						title={title}
						setSheetOpen={setSheetOpen}
						setDescription={setDescription}
					/>
				);
		}
	};

	return <>{renderSlide(point)}</>;
};

export default SlideHandler;
